import type { HttpClient } from '@shared/http/http-client';
import type {
  IShipmentRepository,
  ShipmentListQuery,
} from '@domain/data-contracts/shipment-repository.interface';
import type { Shipment } from '@domain/models/shipment.interface';
import type { PagedResult } from '@domain/models/paging.interface';
import {
  mapShipmentDto,
  mapPaged,
  type ShipmentDto,
  type PagedDto,
} from './mapping.helper';

const BASE = '/api/shipments';

export class ShipmentRepository implements IShipmentRepository {
  public constructor(private readonly http: HttpClient) {}

  public async list(query: ShipmentListQuery): Promise<PagedResult<Shipment>> {
    const response = await this.http.get<PagedDto<ShipmentDto>>(BASE, {
      params: pruneParams(query),
    });
    return mapPaged(response.data, mapShipmentDto);
  }
}

function pruneParams(query: ShipmentListQuery): Record<string, string | number> {
  const out: Record<string, string | number> = {};
  if (query.status) { out.status = query.status; }
  if (query.search && query.search.trim().length > 0) { out.search = query.search.trim(); }
  if (typeof query.page === 'number') { out.page = query.page; }
  if (typeof query.pageSize === 'number') { out.pageSize = query.pageSize; }
  return out;
}
